export default "\ntable{\n  width: 100%;\n}\n\n.input-element{\n  width: 100%\n}\n\n";